import { VStack } from '@vivaahealth/design-system';

import CharacterLimit from '../CharacterLimit';

import defaultStyles from '../../styles/formSetStyles.module.css';

interface Props {
  id?: string;
  placeholder?: string;
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  value?: string;
  characterLimit?: number | null;
}

export const TextInput: React.FC<Props> = ({
  id,
  placeholder,
  saveFieldValue,
  updateFieldValue,
  value,
  characterLimit,
}) => {
  return (
    <VStack gap={8}>
      <div className={defaultStyles.InputWrapper}>
        <input
          id={id}
          className={defaultStyles.Input}
          onBlur={(event: React.FormEvent<HTMLInputElement>) => {
            const cleanedValue = event.currentTarget.value
              .trim()
              .replace(/\s\s+/g, ' ');

            updateFieldValue(cleanedValue);
            saveFieldValue(cleanedValue);
          }}
          onChange={(event: React.FormEvent<HTMLInputElement>) =>
            updateFieldValue(event.currentTarget.value)
          }
          placeholder={placeholder}
          type="text"
          value={value}
          maxLength={characterLimit || undefined}
        />
      </div>
      {characterLimit && (
        <CharacterLimit
          currentLength={value?.length || 0}
          limit={characterLimit}
        ></CharacterLimit>
      )}
    </VStack>
  );
};
